
import React, { useState, useRef, useEffect } from 'react';

const DomineChoosing= () => {
  const ChoosingData = [
    {
      heading: "Affordability",
      description: "We offer competitive pricing plans for domain registration, ensuring accessibility and affordability for businesses of all sizes.",
    },
    {
      heading: "Domain Management",
      description: "We provide comprehensive domain management services, including domain name registration, renewal, transfer, and DNS management, ensuring a seamless and hassle-free experience for our clients.",
    },
    {
      heading: "Security and Privacy",
      description: "We prioritize the security and privacy of our clients' domain names, offering optional domain privacy protection and security features to safeguard against unauthorized access and domain hijacking.",
    },
    {
      heading: "Customer Support",
      description: "We provide dedicated customer support to assist our clients with any domain-related issues or inquiries, ensuring prompt resolution and satisfaction.",
    }
  ];

  return (
    <div  className="col-lg-6">
    <div className="accordions-new is-first-expanded">
      {ChoosingData.map((item, index) => (
        <AccordionItem key={index} title={item.heading} content={item.description} />
      ))}
    </div>
    </div>
  );
};

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        contentRef.current.style.maxHeight = contentRef.current.scrollHeight + 'px';
      } else {
        contentRef.current.style.maxHeight = '0px';
      }
    }
  }, [isOpen]);

  return (
    <article className="accordion">
      <div className="accordion-head" onClick={toggleAccordion}>
        <span>{title}</span>
        <span className={`icon ${isOpen ? 'open' : ''}`}>
          <i className={`fa ${isOpen ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
        </span>
      </div>
      <div
        ref={contentRef}
        className={`accordion-body ${isOpen ? 'open' : ''}`}
        style={{ maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px' }}
      >
        <div className="content">
          <p>{content}</p>
        </div>
      </div>
    </article>
  );
};

export default DomineChoosing;
